import { render, staticRenderFns } from "./message-multiple-attachments.vue?vue&type=template&id=59cd7c4c"
import script from "./message-multiple-attachments.vue?vue&type=script&lang=js"
export * from "./message-multiple-attachments.vue?vue&type=script&lang=js"
import style0 from "./message-multiple-attachments.vue?vue&type=style&index=0&id=59cd7c4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports